import initDialog from '../initDialog'

import { RemoveDialog } from '../RemoveDialog'

import api from '../../../configs/api'

const styles = () => ({});

class RemoveConceptualObjectDialog extends RemoveDialog
{
    getLocale = () => this.props.locale.dialogs.application.conceptualObject.remove ;
}

RemoveConceptualObjectDialog.defaultProps =
{
    ...RemoveDialog.defaultProps,
    uri    : api.conceptualObjects.url,
    useUrl : true
};

RemoveConceptualObjectDialog.propTypes =
{
    ...RemoveDialog.propTypes
};

export default initDialog({ styles })( RemoveConceptualObjectDialog );
